import type { FormProps, Input } from "../types";
import type { ChangeEvent } from "react";

export function InputComponent({
  field,
  formProps,
}: {
  field: Input;
  formProps?: FormProps;
}) {
  const options =
    field.uiOptions?.inputType === "number" ? { valueAsNumber: true } : {};
  const step = field.uiOptions?.attributes?.step
    ? { step: field.uiOptions?.attributes?.step }
    : {};

  // Check if field is required - support both old and new validation formats
  const isRequired =
    field.validations?.some((v) => v === "required") ||
    Boolean(field.validation?.required);

  return (
    <div className="w-full">
      {field.uiOptions?.label && (
        <label
          htmlFor={field.name}
          className={field.uiOptions?.labelClassName || "block text-sm font-medium mb-1 text-slate-50"}
        >
          {field.uiOptions.label}
          {isRequired && (
            <span className="ml-1 align-top text-red-500 text-sm">*</span>
          )}
        </label>
      )}
      <input
        id={field.name}
        type={field.uiOptions?.inputType || "text"}
        placeholder={field.uiOptions?.placeholder}
        readOnly={field.uiOptions?.readOnly}
        disabled={field.uiOptions?.disabled}
        {...step}
        {...formProps?.register(field.name, {
          ...options,
          onChange: (e: ChangeEvent<HTMLInputElement>) => {
            if (field.uiOptions?.inputType === "number") {
              const value = e.target.value.toString();
              if (value.match(/^00/)) {
                formProps.setValue(field.name, value.replace(/^00/, "0"));
              }
              if (value.match(/^0[1-9]/)) {
                formProps.setValue(field.name, value.replace(/^0/, ""));
              }
            }
          },
        })}
        className={field?.uiOptions?.className || "bg-background-light border border-base-input text-slate-50 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary w-full"}
      />
    </div>
  );
}
